module.exports = __webpack_public_path__ + "static/productVideo-380b4e3f8860c56aa1491a77b36f4b9d.mp4";